module.exports = __webpack_public_path__ + "img/details-three.490961b3.png";